import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-why-choose-us',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './why-choose-us.component.html',
  styleUrl: './why-choose-us.component.scss'
})
export class WhyChooseUsComponent {
  reasons = [
    {
      id: 1,
      icon: 'award',
      title: 'Industry Leadership',
      description: 'Recognized as one of the leading construction companies with numerous awards and accolades.',
      features: ['14+ years experience', 'Multiple industry awards', 'Certified excellence']
    },
    {
      id: 2,
      icon: 'users',
      title: 'Expert Team',
      description: 'A dedicated team of architects, engineers, and construction professionals with deep expertise.',
      features: ['120+ skilled professionals', 'Continuous training', 'Subject matter experts']
    },
    {
      id: 3,
      icon: 'shield',
      title: 'Quality Assurance',
      description: 'Rigorous quality control at every stage ensures exceptional results and client satisfaction.',
      features: ['ISO certified', 'Regular inspections', 'Best practices']
    },
    {
      id: 4,
      icon: 'clock',
      title: 'On-Time Delivery',
      description: 'We commit to timelines and deliver projects according to agreed schedules without compromises.',
      features: ['98% on-time record', 'Efficient planning', 'Smart monitoring']
    },
    {
      id: 5,
      icon: 'sliders',
      title: 'Customization',
      description: 'Every project is unique. We tailor our solutions to meet your specific requirements and vision.',
      features: ['Bespoke solutions', 'Client-centric design', 'Flexible approach']
    },
    {
      id: 6,
      icon: 'trending-up',
      title: 'Innovation',
      description: 'Latest technologies and modern construction methods for superior quality and efficiency.',
      features: ['Modern techniques', 'Advanced tools', 'Sustainable practices']
    }
  ];
}
